import {Formik} from 'formik'
import {notificationEmailSchema} from '../../../utils/validation'
import Input from '../../../components/core/input'
import ButtonLoader from '../../../components/core/button/ButtonLoader'
import {SimpleBlueButton} from '../../../components/core/button'
import {useState} from 'react'
import {useDispatch} from 'react-redux'
import {updateChannel} from '../../../stores/customer-settings'
import {trimStringValues} from '../../../utils/text'
import {useNamespaceTranslations} from '../../../utils/hooks/useNamespacesTranslations'

const UpdateEmailChannel = ({data, setModalData, customerId}) => {
    const [buttonIsDisabled, setButtonIsDisabled] = useState(false)
    const text = useNamespaceTranslations('notifications')
    const dispatch = useDispatch()
    const initialFormValues = {
        value: '',
        priority: data?.channel?.priority,
        type: 'email'
    }

    const updateNotificationChannel = async(values, {setFieldError, resetForm}) => {
        setButtonIsDisabled(true)
        const fetchedData = await dispatch(updateChannel(false, customerId, trimStringValues(values), setFieldError))
        if (fetchedData) {
            resetForm()
            setModalData(prev => ({
                ...prev,
                codeModal: true,
                value: values.value,
                type: data?.channel?.type
            }))
        }
        setButtonIsDisabled(false)
    }

    return (
        <Formik initialValues={initialFormValues}
            enableReinitialize={true}
            onSubmit={updateNotificationChannel}
            validationSchema={notificationEmailSchema}
            validateOnBlur={false}
            validateOnChange={false}>
            {({values, errors, handleSubmit, handleChange}) => (
                <form onSubmit={handleSubmit} className="modal-body">
                    <Input
                        name="value"
                        type="email"
                        value={values.value}
                        onChange={handleChange}
                        error={errors.value}
                        placeholder={text.new_channel}
                        infoText={text.email_info}/>
                    <SimpleBlueButton disabled={buttonIsDisabled}
                        type="submit">
                        {buttonIsDisabled && <ButtonLoader/>}
                        {text.next}
                    </SimpleBlueButton>
                </form>
            )}
        </Formik>
    )
}

export default UpdateEmailChannel
